module.exports = __webpack_public_path__ + "11d561629449a066ce04bd4c8d4f0366.svg";